<template>
    <div>
        <h1 style="font-size: 24px; color: black;">广告素材日报
            <span >页面位置：</span>
            <el-select v-model="queryData.materialPosition" clearable placeholder="请选择" @change="searchMaterialReport">
                <el-option v-for="item in positions" :label="item.name" :key="item.id" :value="item.id" ></el-option>
            </el-select>
        </h1>
        <div class="block">
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span>素材名称：</span>
            <el-input v-model="queryData.materialName" style="width: 200px" clearable></el-input>

            <span>素材ID：</span>
            <el-input v-model="queryData.id" style="width: 200px" clearable></el-input>

            <span v-if="queryData.materialPosition !==0">版块名称：</span>
            <el-select v-if="queryData.materialPosition !==0" v-model="queryData.plateName" clearable  placeholder="请选择/输入">
                <el-option
                        v-for="item in plates"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" class="margin-left-10"  @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出</el-button>
        </div>
        <h1>
            <el-table :key="tableKey"
                      :data="materialReport"
                      border
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      max-height="820" >
                <el-table-column prop="dt" label="日期" ></el-table-column>
                <el-table-column prop="id" label="素材ID"></el-table-column>
                <el-table-column prop="materialName" label="素材名称"></el-table-column>
                <el-table-column prop="ranking" label="排序编号"></el-table-column>
                <el-table-column label="素材缩略图">
                    <template slot-scope="scope">
                        <img :src="VUE_APP_CDN_URL+scope.row.materialPicture" width="80px" height="80px" alt=""/>
                    </template>
                </el-table-column>
                <el-table-column label="板块名称" v-if="queryData.materialPosition !==0" >
                    <template slot-scope="scope" v-if="queryData.materialPosition !==0">
                     <span v-if="scope.row.plateName===0">侧边栏</span>
                     <span v-if="scope.row.plateName===1">退出矩阵</span>
                     <span v-if="scope.row.plateName===2">banner矩阵</span>
                     <span v-if="scope.row.plateName===3">挂件矩阵</span>
                     <span v-if="scope.row.plateName===4">插屏矩阵</span>
                    </template>
                </el-table-column>
                <el-table-column label="曝光用户数" >
                    <template slot-scope="scope">
                        {{ scope.row.exUser == null ? '0' : scope.row.exUser }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光次数" >
                    <template slot-scope="scope">
                        {{ scope.row.exposure == null ? '0' : scope.row.exposure }}
                    </template>
                </el-table-column>

                <el-table-column label="点击用户数" >
                    <template slot-scope="scope">
                        {{ scope.row.exUserClick == null ? '0' : scope.row.exUserClick }}
                    </template>
                </el-table-column>

                <el-table-column label="点击次数" >
                    <template slot-scope="scope">
                        {{ scope.row.exClick == null ? '0' : scope.row.exClick }}
                    </template>
                </el-table-column>

                <el-table-column label="用户点击率" >
                    <template slot-scope="scope">
                        {{ scope.row.clRate == null ? '0.00%' : (scope.row.clRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
        allPosition,
        allPlateName,
        searchMaterialReport,
        downloadData,
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        inject: ['reload'],
        name: "MaterialReport",
        data() {
            return {
                checkAll: false,
                tableKey: 1,
                VUE_APP_CDN_URL: null,
                queryData: {
                    id: '',
                    plateName: 0,
                    materialPosition: 0,
                    materialName:'',
                    timeDate: ['', ''],
                },
                positions:[],
                plates:[],
                queryInfo: {
                    pagesize: 20,
                    pagenum: 1,
                    total: 0,
                },
                queryTrueData: {
                    id: '',
                    plateName: 0,
                    materialPosition: 0,
                    materialName:'',
                    startTime: '',
                    order: null,
                    prop: null,
                    endTime: ''
                },
                materialReport: [],
            }
        },
        methods: {
            searchMaterialReport() {
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['', ''];
                }
                this.queryTrueData.id = this.queryData.id;
                this.queryTrueData.startTime = this.queryData.timeDate[0];
                this.queryTrueData.endTime = this.queryData.timeDate[1];
                this.queryTrueData.materialPosition = this.queryData.materialPosition;
                this.queryTrueData.materialName = this.queryData.materialName;
                this.queryTrueData.plateName = this.queryData.plateName;
                this.queryTrueData.size = this.queryInfo.pagesize;
                this.queryTrueData.page = this.queryInfo.pagenum;
                searchMaterialReport(this.queryTrueData).then(resp => {
                    this.materialReport = resp.data.info.list;
                    this.queryInfo.total = resp.data.info.totalElements;
                });
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize;
                this.searchMaterialReport();

            },
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage;
                this.searchMaterialReport();
            },
            query(){
                this.queryInfo.pagenum = 1;
                this.searchMaterialReport();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '广告素材日报.xlsx';
                downloadData(
                    '/adMaterial/exportReportExcel',
                    Object.assign(this.queryTrueData),
                    fileName
                )
            },

        },

        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            allPosition().then(resp=>{
                this.positions = resp.data.info;
            });
            allPlateName().then(resp=>{
                this.plates = resp.data.info;
            });
            this.searchMaterialReport();
            },
        mounted() {
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
